import { render, staticRenderFns } from "./PromoConflictModal.vue?vue&type=template&id=efea5548&"
import script from "./PromoConflictModal.vue?vue&type=script&lang=js&"
export * from "./PromoConflictModal.vue?vue&type=script&lang=js&"
import style0 from "./PromoConflictModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardSubtitle,VCardTitle,VContainer,VDataTable,VDialog,VDivider,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src150092593/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efea5548')) {
      api.createRecord('efea5548', component.options)
    } else {
      api.reload('efea5548', component.options)
    }
    module.hot.accept("./PromoConflictModal.vue?vue&type=template&id=efea5548&", function () {
      api.rerender('efea5548', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PromoConflictModal.vue"
export default component.exports